import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { FiTrash2, FiX } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

function ExcluirModal({ component, texto, onConfirm, onCancel }) {
  return ReactDOM.createPortal(
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: 'rgba(15,23,42,0.55)', backdropFilter: 'blur(3px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontFamily: "'AlteHaasGroteskRegular','Segoe UI',sans-serif",
      }}
      onClick={onCancel}
    >
      <div
        style={{
          width: 420, background: '#fff', borderRadius: 8,
          boxShadow: '0 24px 64px rgba(0,0,0,0.15), 0 2px 8px rgba(0,0,0,0.06)',
          overflow: 'hidden',
          animation: 'excluir-in 0.2s ease-out',
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '18px 20px 16px', borderBottom: '1px solid #f1f5f9',
        }}>
          <span style={{
            fontWeight: 700, fontSize: 15, color: '#111827',
            fontFamily: "'AlteHaasGroteskBold','Segoe UI',sans-serif",
          }}>
            Excluir {component}
          </span>
          <button
            onClick={onCancel}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', display: 'flex', padding: 4, borderRadius: 4, transition: 'color 0.15s' }}
            onMouseEnter={e => e.currentTarget.style.color = '#374151'}
            onMouseLeave={e => e.currentTarget.style.color = '#9ca3af'}
          >
            <FiX size={16} />
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: '16px 20px 0' }}>
          <p style={{ margin: '0 0 16px', color: '#374151', fontSize: 14, lineHeight: 1.65 }}>
            {texto}? Esta ação não pode ser desfeita.
          </p>
        </div>

        {/* Footer */}
        <div style={{ borderTop: '1px solid #f1f5f9', padding: '14px 20px' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <button
              onClick={onCancel}
              style={{
                height: 38, padding: '0 20px', borderRadius: 6, cursor: 'pointer',
                fontFamily: 'inherit', fontSize: 13.5, fontWeight: 500,
                border: '1px solid #d1d5db', background: '#fff', color: '#374151',
                transition: 'background 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#f9fafb'}
              onMouseLeave={e => e.currentTarget.style.background = '#fff'}
            >
              Fechar
            </button>
            <button
              onClick={onConfirm}
              style={{
                height: 38, padding: '0 20px', borderRadius: 6, cursor: 'pointer',
                fontFamily: 'inherit', fontSize: 13.5, fontWeight: 600,
                border: 'none', background: '#ef4444', color: '#fff',
                transition: 'background 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#dc2626'}
              onMouseLeave={e => e.currentTarget.style.background = '#ef4444'}
            >
              Excluir
            </button>
          </div>
        </div>
      </div>
      <style>{`@keyframes excluir-in { from{opacity:0;transform:translateY(14px)} to{opacity:1;transform:translateY(0)} }`}</style>
    </div>,
    document.body
  );
}

export default function Excluir({ url, id, redirect, component, texto }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleDelete = () => {
    setOpen(false);
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: localStorage.getItem('token') },
      body: JSON.stringify({ id }),
    })
      .then(r => r.json())
      .then(res => navigate(`/alerta-sucesso/${res.retorno.mensagem}&${redirect}`));
  };

  return (
    <>
      <FiTrash2 size={14} onClick={() => setOpen(true)} style={{ cursor: 'pointer' }} />
      {open && (
        <ExcluirModal
          component={component}
          texto={texto}
          onConfirm={handleDelete}
          onCancel={() => setOpen(false)}
        />
      )}
    </>
  );
}
